import type { TakeoverCustody } from '../../services/api/types.gen';

/** A claim period the Take Over plan already marked as billable or not. */
export type BillableClaim = {
  start_date: string;
  end_date: string;
  external_emr_can_bill: boolean;
};

/**
 * The External EMR charts every day of a claim ending on `endDate`.
 * Mirrors `external_emr_charts_all_of`: the cut-off is after the claim, or
 * the claim ended before today. ISO dates compare as text.
 */
export function externalEmrChartsAllOf(
  endDate: string,
  chartsFrom: string,
  today: string
): boolean {
  return endDate < chartsFrom || endDate < today;
}

/**
 * Who bills each claim once the cut-off day is chosen. The External EMR
 * keeps a leading run of claims it can bill and charts entirely. The first
 * claim that fails, and every later one, is Roger's.
 */
export function custodyForChartsFrom(
  periods: readonly BillableClaim[],
  chartsFrom: string,
  today: string
): Map<string, TakeoverCustody> {
  const custody = new Map<string, TakeoverCustody>();
  let keeping = true;
  for (const period of periods) {
    const external =
      keeping &&
      period.external_emr_can_bill &&
      externalEmrChartsAllOf(period.end_date, chartsFrom, today);
    if (!external) keeping = false;
    custody.set(period.start_date, external ? 'external_emr' : 'roger');
  }
  return custody;
}
